// extracted by mini-css-extract-plugin
export default {"brikkFooter":"styles_brikkFooter__z4CLc"};